import { debounce } from '@mui/material'
import { useEffect, useMemo, useRef } from 'react'

export const useDebounce = (callback: Function, ms: number = 300) => {
  const ref = useRef<any>({})

  useEffect(() => {
    ref.current = callback
  }, [callback])

  const debouncedCallback = useMemo(() => {
    const func = (...args: any[]) => {
      ref.current?.(...args)
    }

    return debounce(func, ms)
  }, [ms])

  return debouncedCallback
}
